"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));

var _styles = require("@material-ui/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Topbar = _interopRequireDefault(require("../Topbar"));

var _Input = _interopRequireDefault(require("@material-ui/icons/Input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      boxShadow: 'none'
    },
    flexGrow: {
      flexGrow: 1
    },
    signOutButton: {
      marginLeft: theme.spacing(1)
    },
    logoImg: {
      height: 48,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  };
});

var DashboardTopbar = function DashboardTopbar(_ref) {
  var className = _ref.className,
      onSidebarOpen = _ref.onSidebarOpen,
      onSignOut = _ref.onSignOut,
      props = _objectWithoutProperties(_ref, ["className", "onSidebarOpen", "onSignOut"]);

  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Topbar.default, _extends({
    className: className
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.flexGrow
  }), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    mdDown: true
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    color: "inherit",
    onClick: onSignOut
  }, /*#__PURE__*/_react.default.createElement(_Input.default, null))), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    lgUp: true
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    color: "inherit",
    onClick: onSidebarOpen
  }, /*#__PURE__*/_react.default.createElement(_Menu.default, null))));
};

DashboardTopbar.propTypes = {
  className: _propTypes.default.string,
  onSidebarOpen: _propTypes.default.func,
  onSignOut: _propTypes.default.func.isRequired
};
var _default = DashboardTopbar;
exports.default = _default;